import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Refresh = ({
  height = 18,
  width = 20,
  color = colors.textPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 20 18" {...props}>
    <path
      d="M14.7715 5.24993C13.9606 4.26774 12.8664 3.55972 11.6382 3.22251C10.41 2.8853 9.1076 2.93533 7.90887 3.36578C6.71015 3.79623 5.67346 4.58612 4.94033 5.62762C4.20719 6.66913 3.81333 7.91151 3.8125 9.18518V10.8749"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 13.4308C6.35034 14.3319 7.4516 14.9569 8.66119 15.2249C9.87078 15.493 11.133 15.3918 12.2844 14.9344C13.4358 14.477 14.4234 13.6844 15.1193 12.6594C15.8152 11.6343 16.1873 10.424 16.1875 9.18506V8.06006"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5625 8.62256L3.8125 10.8726L6.0625 8.62256"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.4375 10.3101L16.1875 8.06006L13.9375 10.3101"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
